export default "__VITE_ASSET__KmMDQL78__"